import { render, staticRenderFns } from "./SettingAutoLikedContents.vue?vue&type=template&id=27122674"
import script from "./SettingAutoLikedContents.vue?vue&type=script&lang=js"
export * from "./SettingAutoLikedContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports